import { MapPin, Maximize2, Building2, Trees } from "lucide-react";

const stats = [
  { icon: Maximize2, value: "72.25", unit: "Acres", label: "Sprawling Estate" },
  { icon: Building2, value: "558", unit: "Units", label: "Luxury Residences" },
  { icon: Trees, value: "84,000+", unit: "Sq.Ft", label: "Clubhouse Area" },
  { icon: MapPin, value: "70+", unit: "Amenities", label: "World-Class" },
];

export default function ProjectOverview() {
  return (
    <section
      id="overview"
      data-testid="project-overview-section"
      className="py-20 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left text */}
          <div>
            <p className="overline mb-4">The Project</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight text-[#1A1A1A] leading-tight">
              A welcome worthy
              <br />
              of <span className="italic text-[#C5A059]">heritage</span>.
            </h2>
            <div className="gold-line mt-6 mb-8" />
            <p className="text-base md:text-lg text-[#5C5C59] leading-relaxed max-w-lg">
              Spread across 72.25 magnificent acres, La Valora is a testament to
              refined living. With 558 thoughtfully designed residences and an
              84,000+ sq.ft clubhouse, every detail speaks of legacy and luxury.
            </p>
            <p className="text-base md:text-lg text-[#5C5C59] leading-relaxed max-w-lg mt-4">
              Nestled near Financial District, Hyderabad, La Valora offers
              unparalleled connectivity with world-class amenities designed to
              delight all ages.
            </p>
            <div className="mt-6 text-xs text-[#5C5C59]/60 uppercase tracking-wider">
              HMDA Permission No: 012817/LO/HMDA/3450/SKP/2024
            </div>
          </div>

          {/* Right - accent block with image */}
          <div className="relative">
            <div className="bg-[#C5A059]/10 absolute -top-6 -right-6 w-full h-full" />
            <img
              src="../images/build2.png"
              alt="La Valora Project"
              className="relative w-full h-[400px] object-cover"
            />
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`stat-${stat.unit.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="glass-card p-8 md:p-10 text-center group hover:border-[#C5A059]/60 transition-all duration-500"
            >
              <stat.icon
                className="mx-auto mb-4 text-[#C5A059] group-hover:scale-110 transition-transform duration-300"
                size={28}
                strokeWidth={1.5}
              />
              <div className="stat-number text-4xl md:text-5xl font-bold mb-1">
                {stat.value}
              </div>
              <div className="text-sm uppercase tracking-[0.15em] text-[#C5A059] font-semibold mb-2">
                {stat.unit}
              </div>
              <div className="text-sm text-[#5C5C59]">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
